export const SYNC_PRODUCT_STEP = ['Pilih Produk', 'Pilih Variasi Produk']
export const SYNC_PRODUCT_STEP_BUNDLING = ['Pilih Produk']

export const SYNC_PRODUCT_FIELDS = type => [
  {
    key: type === 'product' ? 'name' : 'variant_name',
    label: type === 'product' ? 'Produk di Gudang Kompack' : 'Gudang Kompack',
    thClass: '!normal-case !font-[500] !text-[14px] !font-[#333333]',
  },
  {
    key: 'action',
    label: 'Aksi',
    thClass: '!w-[180px] !normal-case !font-[500] !text-[14px] !font-[#333333]',
  },
]
